import { ChangeEvent } from 'react'
import { Checkbox, checkboxClasses, SxProps, Theme } from '@mui/material'
import clsx from 'clsx'

import { switcherLabelWithImageStyle } from 'common/styles'
import FormControlLabel from 'components/FormControlLabel'
import ImageCard from 'components/ImageCard'
import { concatToSXProp } from 'utils/style'

import { CheckboxImageOption } from '../interface'

interface CheckboxItemWithImageProps {
  option: CheckboxImageOption
  valueState: Record<string, boolean>
  handleChange: (id: string, event: ChangeEvent<HTMLInputElement>) => void
}

const checkboxStyles: SxProps<Theme> = {
  position: 'absolute',
  top: '12px',
  right: '16px',
  padding: 0,
  color: 'rgba(0,0,0, 0.4)',
}

export default function CheckboxItemWithImage({
  option,
  valueState,
  handleChange,
}: CheckboxItemWithImageProps): JSX.Element {
  const { image, heading, subheading, value, imageAltText } = option

  return (
    <FormControlLabel
      className={clsx('control-label', { 'control-label--checked': valueState[value] })}
      sx={concatToSXProp(switcherLabelWithImageStyle, {
        [`.${checkboxClasses.root} + span .image-card-txt-wrap`]: {
          // 96 - image size; 32 - horizontal padding; 16 - margin left
          width: 'calc(100% - 96px - 32px - 16px)',
          flexGrow: 'unset',
        },
      })}
      key={value}
      value={value}
      checked={valueState[value]}
      label={
        <ImageCard
          heading={heading}
          image={image}
          subheading={subheading}
          imageAltText={imageAltText}
        />
      }
      control={
        <Checkbox
          sx={checkboxStyles}
          checked={valueState[value]}
          onChange={(event) => handleChange(value, event)}
        />
      }
    />
  )
}
